import React from "react";
import Navbar from "./Navbar";
import Nav from "./Nav";
import VideoHeader from "./VideoHeader";

export default function Header() {
  return (
    <div className='bg-[url("./assets/ronald-bg-mobile.png")] md:bg-[url("./assets/bg-3.png")] h-[100vh] lg:h-screen bg-cover bg-center'>
      {/* <div className=" h-[100vh] lg:h-screen bg-cover bg-center relative"> */}
      <Navbar />
      {/* 
      <div className="relative h-full w-full bg-white">
        <div className="absolute bottom-0 left-0 right-0 top-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px] "></div>
      </div> */}
      {/* <div className="absolute top-0 left-0 w-full h-full z-0 [mask-image:radial-gradient(ellipse_50%_60%_at_50%_50%,#000_70%,transparent_120%)]">
        <VideoHeader />
      </div> */}
      <div className="flex flex-row justify-center pb-16 md:pb-0 md:justify-center 2xl:mx-10 items-left p-10 text-left gap-4 md:gap-8 h-full items-end">
        <div className="flex flex items-center justify-center gap-6">
          <img
            className="w-full mt-[15vh] md:mt-0 w-[200px] md:w-[35%] 2xl:w-[23%] logo-shadow z-0 md:pb-16"
            src="/logotipo.png"
          />
          <img
            className="w-full mt-[15vh] md:mt-0 w-[110px] md:w-[35%] 2xl:w-[15%] logo-shadow z-0 md:pb-16"
            src="/isotipo.png"
          />
        </div>
      </div>
    </div>
  );
}
